import api from "./httpService";

type CheckoutItem = {
    productId: string;
    quantity: number;
    unitPrice: number;
};

type CheckoutPayload = {
    items: CheckoutItem[];
    total: number;
};

const ENDPOINTS = ["/sales/checkout", "/sales", "/checkout"];
const REPORTS_ENDPOINTS = ["/checkout", "/sales/checkout", "/sales"];

export const checkoutSaleService = async (payload: CheckoutPayload) => {
    let lastError: unknown;

    for (const endpoint of ENDPOINTS) {
        try {
            const response = await api.post(endpoint, payload);
            return response.data;
        } catch (error) {
            lastError = error;
        }
    }

    throw lastError;
};

const toArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") {
        const data = value as { data?: unknown; items?: unknown; sales?: unknown; records?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.sales)) return data.sales;
        if (Array.isArray(data.records)) return data.records;
    }
    return [];
};

export const getSalesReportsService = async () => {
    let lastError: unknown;

    for (const endpoint of REPORTS_ENDPOINTS) {
        try {
            const response = await api.get(endpoint);
            return toArray(response.data);
        } catch (error) {
            lastError = error;
        }
    }

    throw lastError;
};
